import { create } from 'zustand';
import { JawsScanSummaryResponse } from '@/schema/jawsScan';

interface PatientDetailState {
  selectedScan: JawsScanSummaryResponse | null;
  setSelectedScan: (scan: JawsScanSummaryResponse | null) => void;
}

export const patientDetailStore = create<PatientDetailState>((set, get) => {
  return {
    selectedScan: null,
    setSelectedScan: (scan: JawsScanSummaryResponse | null) => {
      set({ selectedScan: scan });
    },
  };
});
